import { createContext, useContext, useState, useEffect } from "react";
import toast from "react-hot-toast";

export const WishListContext = createContext();

export const useWishList = () => useContext(WishListContext);

const WishListProvider = ({ children }) => {
  const [wishList, setWishList] = useState([]);

  useEffect(() => {
    const listItems = localStorage.getItem("wishList");
    setWishList(JSON.parse(listItems) || []);
  }, []);

  
  useEffect(() => {
    localStorage.setItem("wishList", JSON.stringify(wishList));
  }, [wishList]);

  const addWishList = (item) => {
    const existingWishList = wishList.find(
      (list) => list.product_id === item.product_id
    );
    if (!existingWishList) {
      setWishList([...wishList, item]);
      toast.success("Product added to wish list");
      return true;
    } else {
      toast.error("Product already existing");
      return false;
    }
  };

  const removeWishList = (product_id) => {
    const updatedList = wishList.filter((item) => item.product_id !== product_id);
    setWishList(updatedList);
   
  };

  const getExistingWishlist = (id) => {
    return wishList.some((item) => item.product_id === id);
  };

  const getWishList = () => wishList;

  const wishListInfo = {
    getWishList,
    addWishList,
    removeWishList,
    getExistingWishlist,
    wishList
  };

  return (
    <WishListContext.Provider value={wishListInfo}>
      {children}
    </WishListContext.Provider>
  );
};

export default WishListProvider;
